import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import { fieldsAdd, fieldsAddDOS } from './Fields'

const AddItem = (props) => {
  const { open, handleClose, render, setRender, dataInfo, setRows } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [info, setInfo] = useState({
    empresa: dataInfo.cajaInfo.origen,
    fecha: dataInfo.cajaInfo.fecha,
    sucursal: dataInfo.cajaInfo.sucursal,
    efectivo: null,
    debito: null,
    credito: null,
    mercadoPago: null,
    cheque: null,
    deposito: null,
    transferencia: null,
    extranjera: null,
  })

  const handleChange = (name, value) => {
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  function _renderStepContent() {
    return dataInfo.cajaInfo.origen === 1 ? (
      <InputsWithoutValidate fields={fieldsAdd(info, handleChange)} spacing={2} />
    ) : (
      <InputsWithoutValidate fields={fieldsAddDOS(info, handleChange)} spacing={2} />
    )
  }

  const addProducts = async () => {
    setIsLoading(true)
    const [dia, mes, año] = info.fecha.split('/')
    const fechaFormateada = `${año}-${mes}-${dia}`
    const body = {
      ...info,
      fecha: fechaFormateada,
    }
    await interfaces.salesCaja
      .confirmCaja(body)
      .then((res) => {
        setRows((prevRows) => [...prevRows, { ...info }])
        // setData((prevData) => ({
        //   ...prevData,
        //   cajas: [...prevData.cajas, { ...info }],
        // }))
        setRender(!render)
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Error', {
          variant: 'error',
        })
      })
    setIsLoading(false)
    handleClose()
  }

  const isSubmitDisabled = () => {
    const hasValue = (val) => val !== null && val !== undefined && String(val).trim() !== ''

    if (info.empresa === 3) {
      return !(hasValue(info.efectivo) && hasValue(info.cheque) && hasValue(info.extranjera))
    }

    if (info.empresa === 1 || info.empresa === 2) {
      return !(
        hasValue(info.efectivo) &&
        hasValue(info.debito) &&
        hasValue(info.credito) &&
        hasValue(info.mercadoPago) &&
        hasValue(info.cheque) &&
        hasValue(info.deposito) &&
        hasValue(info.transferencia) &&
        hasValue(info.extranjera)
      )
    }

    return !info.empresa || !info.sucursal
  }

  return (
    <DialogComponent
      title="Cargar caja"
      open={open}
      handleclose={handleClose}
      handleclosedisabled={isLoading}
      widthLarge="500px"
      disableBackdropClick
      disableEscapeKeyDown
      maxHeight
      children={
        <>
          <div>{_renderStepContent()}</div>
        </>
      }
      actions={
        <CancelConfirmButtons
          disabledSubmit={isLoading || isSubmitDisabled()}
          disabledCancel={isLoading}
          isLoading={isLoading}
          onClickSubmit={addProducts}
          onClickCancel={handleClose}
        />
      }
    />
  )
}
export default AddItem
